// extracted by mini-css-extract-plugin
var _1 = "SettingsCompanyNavigation_desktopContainer__QUFJT";
var _2 = "SettingsCompanyNavigation_hideScroll__Ecp--";
export { _1 as "desktopContainer", _2 as "hideScroll" }
